import AxiosInstance from "../Utils/axios/axiosConfig";
import {getAccessToken} from "./localStorageServices";

export const forgotPassword = async (email = "") => {
  const response = await AxiosInstance.post("/forgot-password/", {
    email,
  });
  return response;
};
export const confirmForgotPassword = async (
  email = "",
  password = "",
  code = ""
) => {
  const response = await AxiosInstance.post("/forgot-password/confirm/", {
    email,
    password,
    code,
  });
  return response;
};
export const changePassword = async (body) => {
  try {
    const accessToken = getAccessToken();
    const response = await AxiosInstance.post("/change-password/", {
      ...body,
      access_token: accessToken,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response || error);
  }
};

